// Feature flags for the patient portal.
// Backend endpoints for these features are not yet built (post-launch).
// Set a flag to `true` once its backend endpoints exist to re-enable the
// corresponding nav entry + route.
export const FEATURES = {
  prescriptions: false,
  labReports: false,
  carePlans: false,
  webmd: false,
} as const;
